// Validate email has is correct format
export const emailPattern = '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$'
// Validate password is correct; 12-32 characters, at least 1: uppercase and lowercase letters, number and special character
export const passwordPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-~]).{12,32}$'

// Validate URL (do not require HTTP protocol)
export const urlPattern =
  '[Hh]?[Tt]?[Tt]?[Pp]?[Ss]?:?/?/?(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::d{2,5})?(?:/[^s]*)?'
